export function getSharedNumber(firstCard: number[], secondCard: number[]): number {
    let sharedNumber = -1;
    for (let i = 0; i < firstCard.length; i++) {
        const numberToSearch = firstCard[i];
        if (secondCard && secondCard.includes(numberToSearch)) {
            sharedNumber = numberToSearch;
            return sharedNumber;
        }
    }
    return sharedNumber;
}